import React, { lazy, Suspense } from 'react';

// VerticalWidget props: { data, onAction, theme, locale }

const VERTICAL_LOADERS = {
  'vertical:transport.seat_map.v1': () => import('../verticals/transport/seat_map/v1/index.jsx'),
  'vertical:transport.ticket_qr.v1': () => import('../verticals/transport/ticket_qr/v1/index.jsx'),
  'vertical:transport.trip_options.v1': () => import('../verticals/transport/trip_options/v1/index.jsx'),
  'vertical:transport.route_timeline.v1': () => import('../verticals/transport/route_timeline/v1/index.jsx'),
  'vertical:transport.hold_timer.v1': () => import('../verticals/transport/hold_timer/v1/index.jsx'),
  'vertical:transport.checkout.v1': () => import('../verticals/transport/checkout/v1/index.jsx'),
};

const cache = {};

export function isVerticalKey(name) {
  return typeof name === 'string' && name.startsWith('vertical:');
}

export function getVerticalComponent(key) {
  const loader = VERTICAL_LOADERS[key];
  if (!loader) return null;
  if (!cache[key]) {
    cache[key] = lazy(loader);
  }
  return cache[key];
}

export function VerticalWidgetShell({ keyName, data, onAction, theme, locale, disabled, dir, partId, actions }) {
  const Component = getVerticalComponent(keyName);
  if (!Component) {
    return <div className="ui-part-unknown">Unknown vertical: {keyName}</div>;
  }
  return (
    <Suspense fallback={<div className="ui-part-loading">Loading…</div>}>
      <Component
        data={data}
        onAction={onAction}
        theme={theme}
        locale={locale}
        disabled={disabled}
        dir={dir}
        partId={partId}
        actions={actions}
      />
    </Suspense>
  );
}
